var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _circle, _circle2, _rect3, _rect4, _circle3, _circle4, _rect5, _path6, _path7, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle5, _circle6, _circle7, _circle8, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyCart = function SvgEmptyCart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 210
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.922 94.6411C97.6015 83.842 77.0173 56.919 85.2442 35.619C95.5279 8.9939 140.713 27.9397 124.964 53.6891C112.365 74.2887 74.0493 47.8654 56.4664 32.0788",
    stroke: "#BBDEFB",
    strokeWidth: 1.00675,
    strokeDasharray: "2.01 2.01"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0045,
    y: 30.3226,
    width: 2.68467,
    height: 6.0405,
    rx: 1.34233,
    transform: "rotate(131.039 56.0045 30.3226)",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9341 33.8361C52.8969 34.4511 52.3682 34.9196 51.7531 34.8824C51.138 34.8452 50.6696 34.3164 50.7068 33.7014L50.8414 31.474C50.8786 30.859 51.4074 30.3905 52.0225 30.4277C52.6375 30.4649 53.106 30.9937 53.0688 31.6087L52.9341 33.8361Z",
    fill: "#BBDEFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1702 32.3101C48.5875 32.5103 47.9527 32.2002 47.7525 31.6175C47.5523 31.0347 47.8624 30.4 48.4452 30.1998L50.5555 29.4747C51.1382 29.2745 51.773 29.5846 51.9732 30.1674C52.1734 30.7501 51.8633 31.3848 51.2805 31.5851L49.1702 32.3101Z",
    fill: "#BBDEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1402 29.0041C57.7443 28.8825 58.1354 28.2942 58.0137 27.6901C57.8921 27.0861 57.3038 26.6949 56.6998 26.8166L54.5123 27.257C53.9082 27.3786 53.5171 27.9669 53.6387 28.5709C53.7603 29.175 54.3486 29.5661 54.9527 29.4445L57.1402 29.0041Z",
    fill: "#BBDEFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1103 25.4861C55.2283 24.8813 54.8336 24.2954 54.2289 24.1774C53.6241 24.0594 53.0381 24.4541 52.9202 25.0589L52.4929 27.249C52.3749 27.8538 52.7696 28.4397 53.3744 28.5577C53.9791 28.6757 54.5651 28.281 54.683 27.6762L55.1103 25.4861Z",
    fill: "#BBDEFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.1381,
    cy: 172.522,
    r: 10.3228,
    transform: "rotate(-13.2768 89.1381 172.522)",
    fill: "url(#paint0_linear_283_14759)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.1379,
    cy: 172.521,
    r: 5.06621,
    transform: "rotate(-13.2768 89.1379 172.521)",
    fill: "#7AC3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.2419,
    y: 146.838,
    width: 4.62305,
    height: 28.8941,
    rx: 2.31153,
    transform: "rotate(-22.005 76.2419 146.838)",
    fill: "#D6ECFE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.972,
    y: 149.697,
    width: 4.62305,
    height: 28.8941,
    rx: 2.31153,
    transform: "rotate(-22.005 57.972 149.697)",
    fill: "#D6ECFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.508,
    cy: 161.977,
    r: 10.3228,
    transform: "rotate(-13.2768 156.508 161.977)",
    fill: "url(#paint1_linear_283_14759)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.508,
    cy: 161.977,
    r: 5.06621,
    transform: "rotate(-13.2768 156.508 161.977)",
    fill: "#7AC3FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4753,
    y: 69.7325,
    width: 5.06732,
    height: 27.1201,
    rx: 2.53366,
    transform: "rotate(-19.6246 52.4753 69.7325)",
    fill: "#D6ECFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7289 94.2656C58.7441 91.533 60.4935 88.5799 63.3632 88.1308L155.159 73.7635C157.997 73.3193 160.549 75.5438 160.496 78.4161L159.437 135.904C159.396 138.148 157.748 140.039 155.53 140.386L84.3477 151.527C82.1588 151.87 80.0347 150.611 79.2836 148.527L59.7289 94.2656Z",
    fill: "url(#paint2_linear_283_14759)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1754 97.4823C38.1906 94.7497 39.9401 91.7966 42.8098 91.3475L140.044 76.129L138.884 139.12C138.843 141.365 137.195 143.256 134.976 143.603L63.7942 154.744C61.6054 155.086 59.4812 153.828 58.7301 151.744L39.1754 97.4823Z",
    fill: "url(#paint3_linear_283_14759)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8343,
    y: 98.7801,
    width: 2.31153,
    height: 49.1432,
    rx: 1.15576,
    transform: "rotate(-19.5424 55.8343 98.7801)",
    fill: "#BDE0FD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8045,
    y: 96.0499,
    width: 2.31153,
    height: 49.1432,
    rx: 1.15576,
    transform: "rotate(-17.0013 71.8045 96.0499)",
    fill: "#BDE0FD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90.1042,
    y: 92.7722,
    width: 2.31153,
    height: 49.1432,
    rx: 1.15576,
    transform: "rotate(-8.89536 90.1042 92.7722)",
    fill: "#B3DCFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 107.746,
    y: 90.034,
    width: 2.31153,
    height: 49.1432,
    rx: 1.15576,
    transform: "rotate(-2.55871 107.746 90.034)",
    fill: "#B3DCFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 125.933,
    y: 87.2699,
    width: 2.31153,
    height: 49.1432,
    rx: 1.15576,
    transform: "rotate(-0.282453 125.933 87.2699)",
    fill: "#ABD9FE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 144.732,
    y: 84.2603,
    width: 2.31153,
    height: 49.1432,
    rx: 1.15576,
    transform: "rotate(0.995217 144.732 84.2603)",
    fill: "#BFE2FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 151.935,
    y: 83.3472,
    width: 1.54746,
    height: 49.1432,
    rx: 0.773731,
    transform: "rotate(0.995217 151.935 83.3472)",
    fill: "#C9E6FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 156.743,
    y: 82.7958,
    width: 1.42128,
    height: 49.1432,
    rx: 0.71064,
    transform: "rotate(0.995217 156.743 82.7958)",
    fill: "#C9E6FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 68.3445,
    y: 178.598,
    width: 4.62305,
    height: 92.4611,
    rx: 2.31152,
    transform: "rotate(-98.8954 68.3445 178.598)",
    fill: "#D6ECFE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0723,
    y: 78.372,
    width: 6.93458,
    height: 41.6075,
    rx: 3.46729,
    transform: "rotate(-98.8954 21.0723 78.372)",
    fill: "#D6ECFE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9219,
    y: 72.9498,
    width: 5.06732,
    height: 27.1201,
    rx: 2.53366,
    transform: "rotate(-19.6246 31.9219 72.9498)",
    fill: "#D6ECFE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.7261,
    cy: 175.56,
    r: 10.3228,
    transform: "rotate(-13.2768 69.7261 175.56)",
    fill: "url(#paint4_linear_283_14759)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.7259,
    cy: 175.56,
    r: 5.06621,
    transform: "rotate(-13.2768 69.7259 175.56)",
    fill: "#7AC3FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.238,
    cy: 164.837,
    r: 10.3228,
    transform: "rotate(-13.2768 138.238 164.837)",
    fill: "url(#paint5_linear_283_14759)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.238,
    cy: 164.837,
    r: 5.06621,
    transform: "rotate(-13.2768 138.238 164.837)",
    fill: "#7AC3FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    rx: 52.5872,
    ry: 1.73364,
    transform: "matrix(-1 0 0 1 114.195 192.812)",
    fill: "url(#paint6_linear_283_14759)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_14759",
    x1: 84.714,
    y1: 173.259,
    x2: 94.5001,
    y2: 175.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_14759",
    x1: 152.084,
    y1: 162.715,
    x2: 161.87,
    y2: 165.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_283_14759",
    x1: 130.184,
    y1: 102.824,
    x2: 163.794,
    y2: 104.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_283_14759",
    x1: 127.486,
    y1: 50.075,
    x2: 22.2725,
    y2: 53.8602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_283_14759",
    x1: 65.302,
    y1: 176.297,
    x2: 75.0881,
    y2: 178.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_283_14759",
    x1: 133.814,
    y1: 165.574,
    x2: 143.6,
    y2: 167.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_283_14759",
    x1: 117.126,
    y1: 0.231153,
    x2: 116.193,
    y2: 12.8784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-cart.781e271ea0e20012a2d9679ac50e6cf8.svg";